import { Fragment, ReactNode } from "react";

/** Escape a user string so it can be used literally inside a RegExp. */
function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Split `text` on every case-insensitive occurrence of `term` and wrap the
 * matches so they stand out (Claude-style search highlighting). Returns the
 * plain text unchanged when `term` is empty.
 */
export function highlightText(text: string, term: string): ReactNode {
  const query = term.trim();
  if (!query) {
    return text;
  }

  const parts = text.split(new RegExp(`(${escapeRegExp(query)})`, "gi"));
  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark
        key={index}
        className="bg-transparent font-semibold text-majorelle"
      >
        {part}
      </mark>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    ),
  );
}
